import { memo } from "react"

import { dictionariesFetchConfig } from "domain/globalConfig//dictionary/dictionariesFetch.config"
import { useInitDictionary } from "domain/globalConfig/dictionary/hooks/useInitDictionary"

import { useInitWebhookEvents } from "../webhook/hooks/useInitWebhookEvents"
import { useInitUserGroups } from "../userGroups/hooks/useInitUserGroups"

export const GlobalConfigContainer = memo((): null => {
  dictionariesFetchConfig.forEach(({ key, url }) => {
    useInitDictionary(key, url)
  })
  useInitWebhookEvents()
  useInitUserGroups()

  return null
})
